import { useEffect, useState } from "react";
import { Elements } from "@stripe/react-stripe-js";
import CheckoutForm from "./CheckoutForm";
import { loadStripe } from "@stripe/stripe-js";
import MasterCard from "../../../Assets/mastercard.png";
import UnionPay from "../../../Assets/unionPay.jpg";
import Visa from "../../../Assets/Visa.png";
import AE from "../../../Assets/AE.png";
import JCB from "../../../Assets/JCB.jpg";
import { useSelector, useDispatch } from "react-redux";
import { fetchClientSecret } from "../../../redux/recueslice/addressSlice";
//import "../../../Style/QuickViewBuiding/QuickViewBuilding.scss";
import "../../../Style/PaymentMethod/PaymentMethod.scss"
import {
  setPaymentMethodId,
  setUserId,
  clientSecret,
  customerName,
} from "../../../redux/recueslice/addressSlice";
const publishableKey =
  "pk_test_51PVFxWP91pMZMWO6WoVf5obYK9SntUcQTKOcArC925W0l8yprSoKmDd7YREaSkJX5sJrB3QxZ0RtXIzKxZa8zmtk00xIWrO9SM";

function PaymentMethod() {
  const dispatch = useDispatch();

  const { clientSecret, customerName, paymentMethods, status } = useSelector(
    (state) => state.addresses
  );

  const adminId = localStorage.getItem("adminId");
  const [stripePromise, setStripePromise] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState(null);
  const [windowWidth, setWindowWidth] = useState(window.innerWidth);
  const [error, setError] = useState(null);
  const getAdminId = localStorage.getItem("adminId");

  useEffect(() => {
    const initializeStripe = async () => {
      const stripe = await loadStripe(publishableKey);
      setStripePromise(stripe);
    };

    initializeStripe();
  }, []);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          `https://stonecore-2024.uc.r.appspot.com/v1/stripe/info/${getAdminId}`
        );
        if (!response.ok) {
          throw new Error("Failed to fetch data");
        }
        const result = await response.json();

        setData(result);
        if (result.paymentMethods && result.paymentMethods.length > 0) {
          // Extract all payment method IDs
          const paymentMethodIds = result.paymentMethods.map(
            (method) => method.id
          );
          dispatch(setPaymentMethodId(paymentMethodIds));
        }
        if (result.customerInfo) {
          dispatch(setUserId(result.customerInfo._id));
        }
      } catch (error) {
        setError(error.message);
      } finally {
        setIsLoading(false);
      }
    };

    fetchData();
  }, [data]);

  const handleAddUserClick = () => {
    dispatch(fetchClientSecret(adminId));
  };

  const paymentMethod = data?.paymentMethods?.[0]?.card;

  const getCardImage = (brand) => {
    switch (brand) {
      case "visa":
        return Visa;
      case "mastercard":
        return MasterCard;
      case "unionpay":
        return UnionPay;
      case "amex":
        return AE;
      case "jcb":
        return JCB;
      default:
        return null; // You can return a default image or handle this case appropriately
    }
  };

  // useEffect(() => {
  //   const handleResize = () => setWindowWidth(window.innerWidth);

  //   window.addEventListener("resize", handleResize);
  //   return () => window.removeEventListener("resize", handleResize);
  // }, [windowWidth]);


  // const cardStyle = {
  //   width: windowWidth > 600 ? "50%" : "100%",
  //   // width: "100%", // Default for small screens
  //   alignItems: "center",
  //   display: "flex",
  //   flexDirection: "row",
  //   justifyContent: "space-between",
  // };

  // if (window.innerWidth > 600) {
  //   cardStyle.width = "50%"; // For screens wider than 600px
  // }

  return (
    <>
      <button
        className="p-2"
        style={{
          border: "none",
          backgroundColor: "#08085a",
          color: "#ffffff",
          borderRadius: "5px",
        }}
        onClick={handleAddUserClick}
        disabled={isLoading}
      >
        {isLoading ? "Loading..." : "ADD NEW CARD"}
      </button>
      {!isLoading && clientSecret && stripePromise && (
        <Elements stripe={stripePromise} options={{ clientSecret }}>
          <CheckoutForm
            clientSecret={clientSecret}
            customerName={customerName}
          />
        </Elements>
      )}

      {data &&
        data.paymentMethods &&
        data.paymentMethods.map((paymentMethod, index) => (
          <div
            key={index}
            className=" mt-5 p-3 shadow payment-method-container-card-info "
          // style={{ cardStyle, justifyContent: "space-between", display: "flex" }}
          //style={{ width: "auto", alignItems: "center", display: "flex", flexDirection: "row", justifyContent: "space-between" }}
          >
            <div>
              <b>************</b>
              {paymentMethod.card.last4}
            </div>
            <div>
              <span>
                {paymentMethod.card.exp_month}/ {paymentMethod.card.exp_year}
              </span>
            </div>
            <div>
              <img
                src={getCardImage(paymentMethod.card.brand)}
                alt={paymentMethod.card.brand}
                style={{ width: 50, height: 22 }}
              />
            </div>
            {/* <div>
              <button
                className=" p-2 bg-primary"
                style={{
                  border: "none",
                  color: "#ffffff",
                  borderRadius: "5px",
                }}
              >
                Delete
              </button>
            </div> */}
            {/* <div>
              <button
                className=" p-2 bg-primary"
                style={{
                  border: "none",
                  color: "#ffffff",
                  borderRadius: "5px",
                }}
              >
                Edit
              </button>
            </div> */}
          </div>
        ))}
    </>
  );
}

export default PaymentMethod;
